import interfaces from 'blockscope-interfaces';
import { z } from 'zod';

export const MessageServices = interfaces.dragon.AI.MessageServices;

const OtherMessageTypes = z.enum(['chunk', 'error']);

export const AllMessageTypes = z.union([MessageServices, OtherMessageTypes]);

/**
 * @typedef {z.infer<AllMessageTypes>} AllMessageType
 */
